import { render, staticRenderFns } from "./DeleteReferralModal.vue?vue&type=template&id=e59b0a1c&"
import script from "./DeleteReferralModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteReferralModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports